import React, { useCallback, useEffect, useState } from 'react';

import styled from '@emotion/styled';
import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
} from 'date-fns';
import { useTranslations } from 'next-intl';

import { EXPLAIN_TIMER_COMMAND, ICommandDefinition } from './commands';
import { CommandButton, CommandLineEntry } from './common';

const Message = styled(CommandLineEntry)`
  gap: ${({ theme }) => theme.spacing('0500')};
`;

export interface ITimerMessageProps {
  endDate: Date;
  onRunCommand(command: ICommandDefinition): void;
}

export function TimerMessage({ endDate, onRunCommand }: ITimerMessageProps) {
  const t = useTranslations();
  const calculateTimeLeft = useCallback((): string => {
    const now = new Date();
    const days = differenceInDays(endDate, now);
    const hours = differenceInHours(endDate, now) - days * 24;
    const minutes =
      differenceInMinutes(endDate, now) - days * 24 * 60 - hours * 60;

    return [
      `${days.toString().padStart(2, '0')}D`,
      `${hours.toString().padStart(2, '0')}H`,
      `${minutes.toString().padStart(2, '0')}M`,
    ].join(':');
  }, [endDate]);

  const [formattedCountdown, setFormattedCountdown] =
    useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setFormattedCountdown(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [calculateTimeLeft]);

  return (
    <Message centered>
      {t.rich(EXPLAIN_TIMER_COMMAND.message, {
        button: (chunks) => (
          <CommandButton onClick={() => onRunCommand(EXPLAIN_TIMER_COMMAND)}>
            {chunks}
          </CommandButton>
        ),
        countdown: () => <>{formattedCountdown}</>,
      })}
    </Message>
  );
}
